<template>
  <div>
    <div class="user-action-list" v-if="!loading">
      <!-- 没有找到用户信息 -->
      <div class="user-info-not-found" v-if="!userInfo">
        <img
          src="../../../../assets/imgs/work-wx/customer/customer-behavior-list/none-info.png"
        />
        <div class="none-info-text">未检测到该用户信息</div>
      </div>

      <div class="action-list-wrapper" v-else>
        <div class="header">
          <div class="header-title">
            <span class="back-icon" @click="$router.go(-1)"></span>
            客户信息 /
            <span class="weight">客户行为</span>
          </div>
        </div>

        <div class="action-list" v-if="behaviorList && behaviorList.length">
          <customer-behavior-item
            v-for="(behavior, index) in behaviorList"
            :key="index"
            :behavior-item="behavior"
          ></customer-behavior-item>
        </div>
      </div>
    </div>

    <div class="loading" v-else>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>

<script>
import utils from '@/services/tools';
import workWxCommonService from '@/pages/work-wx/services/work-wx-common-service';
import customerService from '../services/customer-service.js';
import customerBehaviorListService from '../services/customer-behavior-list-service.js';
import CustomerBehaviorItem from './components/customer-behavior-item';

export default {
  components: {
    CustomerBehaviorItem,
  },
  data() {
    return {
      loading: false,
      userInfo: undefined,
      behaviorList: [],
    };
  },
  mounted() {
    this.loading = true;
    this.init().finally(() => {
      this.loading = false;
    });
  },
  methods: {
    async init() {
      try {
        await workWxCommonService.commonLogin();
        await this.getUserInfo();
        await this.getUserBehaviorList();
      } catch (e) {
        utils.showError(e);
      }
    },

    // 获取同业信息
    async getUserInfo() {
      try {
        const res = await customerService.userInfoQuery();
        this.userInfo = res;
      } catch (e) {
        const err = { msg: '获取同业信息失败' };
        throw err;
      }
    },

    // 获取客户前20行为
    async getUserBehaviorList() {
      try {
        const res = await customerBehaviorListService.getUserBehaviorList({
          user_account_id: +this.$route.query.id || undefined,
        });
        this.behaviorList = res.page_data;
      } catch (e) {
        throw e;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-action-list {
  background: #f7f8fa;
  font-size: 12px;
  .header {
    background-color: #fff;
    border: 1px solid #ededed;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #6f6f6f;
      line-height: 22px;
      .back-icon {
        margin-right: 4px;
        display: inline-block;
        background-image: url('../../../../assets/imgs/work-wx/customer/customer-behavior-list/arrow-left.png');
        background-size: 100% 100%;
        background-position: center center;
        background-repeat: no-repeat;
        width: 16px;
        height: 16px;
      }
      .weight {
        margin-left: 4px;
        color: #222222;
        font-weight: 600;
      }
    }
  }
  .action-list {
    margin-top: 12px;
    padding: 12px;
    background-color: #fff;
  }
}

.user-info-not-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  .none-info-text {
    font-size: 16px;
    margin-top: 20px;
  }
}

.loading {
  width: 100%;
  padding-top: 100px;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
  text-align: center;
}
</style>
